import template from './mx-search-query-group.directive.html';
import { GroupType } from '../../model/enumerations';

/**
 * @ngdoc directive
 * @name mx.SolutionBuilderAgent:mxSearchQueryGroup
 * @module mx.SolutionBuilderAgent
 * @restrict 'E'
 * @scope {}
 * @requires mx.components.Recursion
 * @requires mx.shell.EventService
 * @requires {@ref mx.shell.SearchProviderService mx.shell.SearchProviderService}
 * @description
 * A group of search conditions. Used to group query conditions on {@ref mx.shell:mxSearchQueryBuilder form} that allows to create or update complex search queries
 * @param {mx.SolutionBuilderAgent.SearchQueryGroup} group= - {@ref mx.shell.SearchQueryGroup Search query conditions group model}
 * @param {mx.SolutionBuilderAgent.SearchQueryGroup} parent= - Parent search query conditions group
 * @param {mx.shell.SearchContext} context= - Reference to a {@ref mx.shell.SearchContext search context model}
 * related to search query being selected for update
 * @usage <mx-search-query-group data-context="vm.context" data-group="subGroup" data-parent="vm.group"></mx-search-query-group>
 */
angular.module('mx.SolutionBuilderAgent').directive('mxSearchQueryGroup', [
	'mx.components.Recursion',
	'mx.shell.SidebarService',
	'mx.app.DeviceService',
	'mx.shell.EventService',
	'mx.shell.UserProfileService',
	'mx.shell.SearchProviderService',
	'mx.SolutionBuilderAgent.SearchQueryService',
	'mx.SolutionBuilderAgent.mxColumnDefinitionService',
	function mxSearchQueryGroupDirective(recursion, sidebarService, deviceService, eventService, userProfileService, searchService, searchQueryService, columnDefinitionService) {
		MxSearchQueryGroupCtrl.$inject = ['$scope', '$q', 'mx.internationalization'];

		function MxSearchQueryGroupCtrl($scope, $q, i18n) {
			const vm = this;
			let propertiesPromise;
			vm.$onInit = function () {
				vm.operatorTitle = operatorTitle;
				vm.filter = { Title: '' };
				vm.level = Number(vm.level || 1);
				vm.checkConditions = () => searchQueryService.validateGroup(vm.group);

				vm.allowSave = vm.showSaveBtn?.toLowerCase() === 'true';
				vm.showTestQueryBtn = vm.showTestQueryBtn?.toLowerCase() === 'true';

				vm.logicalOperators = mx.shell.SearchQueryLogicalOperator;
				vm.toggleLogicalOperator = toggleLogicalOperator;
				vm.toggleParentLogicalOperator = toggleParentLogicalOperator;
				vm.groupHeaderClick = groupHeaderClick;
				vm.addGroup = addGroup;
				vm.deleteGroup = deleteGroup;
				vm.addConditionClick = addConditionClick;
				vm.addCondition = addCondition;
				vm.addExpressionCondition = addExpressionCondition;
				vm.editInQueryBuilder = editInQueryBuilder;
				vm.testQuery = run;
				vm.getHintDenyingSave = getHintDenyingSave;
				vm.allowExpressions = false;

				propertiesPromise = (
					!vm.context.datasource ? $q.when({ Columns: [] }) : columnDefinitionService.getGridDefinitionById(vm.context.datasource, vm.context.widgetId)
				).then((data) => {
					vm.dataQuery = data;
					vm.context.className = data.SchemaClassName;
					const columns = data.Columns.filter((column) => column.IsAvailableInSearch).sort((a, b) => a.Title.localeCompare(b.Title));
					if (vm.context.className) {
						return userProfileService.isCustomizationMode().then((result) => {
							vm.allowExpressions = result;
							return columns;
						});
					}
					return columns;
				});

				const event = eventService.subscribeTo(mx.SolutionBuilderAgent.Events.SearchGroupToggleExpanded, toggleGroupExpanded, $scope);

				$scope.$on('$destroy', function () {
					event();
				});
			};

			function addConditionClick() {
				if (!vm.conditionProperties) {
					propertiesPromise.then(function (properties) {
						vm.conditionProperties = properties || [];
					});
				}
			}

			function toggleOperator(operator) {
				if (operator === mx.SolutionBuilderAgent.SearchQueryLogicalOperator.AND) {
					return mx.SolutionBuilderAgent.SearchQueryLogicalOperator.OR;
				} else {
					return mx.SolutionBuilderAgent.SearchQueryLogicalOperator.AND;
				}
			}

			function toggleLogicalOperator(event) {
				if (event) {
					event.stopPropagation();
				}

				vm.group.logicalOperator = toggleOperator(vm.group.logicalOperator);
			}

			function toggleParentLogicalOperator(event) {
				if (event) {
					event.stopPropagation();
				}

				vm.parent.logicalOperator = toggleOperator(vm.parent.logicalOperator);
			}

			function groupHeaderClick(event) {
				if (event) {
					event.stopPropagation();
				}

				if (vm.readOnly) {
					return;
				}

				const expanded = vm.group.conditions.length ? vm.group.conditions[0].__expanded : false;

				if (vm.level === 1) {
					eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.SearchGroupToggleExpanded, expanded);
				} else {
					toggleGroupExpanded(null, expanded);
				}
			}

			function toggleGroupExpanded(event, expanded) {
				vm.group.conditions.forEach(function (c) {
					c.__expanded = !expanded;
				});
			}

			function addCondition(event, property, group) {
				searchQueryService.createConditionByColumn(property.Name, vm.dataQuery).then((condition) => {
					if (condition) {
						group.conditions.push(condition);
					}
				});
			}

			function addExpressionCondition(event, group) {
				searchQueryService.createExpressionCondition().then((condition) => {
					group.conditions.push(condition);
				});
			}

			function operatorTitle(id) {
				switch (id) {
					case vm.logicalOperators.AND:
						return i18n.get('solutionBuilderAgent.components.mx-search-query-group.operatorAND');
					case vm.logicalOperators.OR:
						return i18n.get('solutionBuilderAgent.components.mx-search-query-group.operatorOR');
					default:
						return '';
				}
			}

			function addGroup(event) {
				if (event) {
					event.stopPropagation();
				}
				vm.group.addGroup(searchQueryService.createQueryGroup());
			}

			function deleteGroup(event) {
				if (event) {
					event.stopPropagation();
				}
				if (vm.parent) {
					vm.parent.removeGroup(vm.group);
				}
			}

			function run(event) {
				if (event) {
					event.stopPropagation();
				}

				if (deviceService.screenMobile()) {
					sidebarService.close();
				}

				searchService.currentSearch().searchForm.setGroup(vm.group, GroupType.QueryBuilder);

				searchService.runSearch();
			}

			function editInQueryBuilder(event) {
				if (event) {
					event.stopPropagation();
				}

				if (vm.allowSave) {
					const query = searchQueryService.createQuery({
						Group: vm.group.toJSON(),
						Parent: vm.context.navigationItem?.originFilterReference?.Id,
					});

					searchQueryService.initQueryByContext(query, vm.context).then(() => {
						searchQueryService.openFilterDialog(query, vm.context);
					});
				}
			}

			function getHintDenyingSave() {
				let currentNavItem = vm.context.navigationItem;
				let currentNavPath = '';
				let allowedNavPath = '';
				let allowedNavPathFound = false;
				do {
					currentNavPath = currentNavItem.title + ' / ' + currentNavPath;
					if (allowedNavPathFound || !currentNavItem.originFilterReference || currentNavItem.originFilterReference.CanEdit) {
						allowedNavPath = currentNavItem.title + ' / ' + allowedNavPath;
						allowedNavPathFound = true;
					}
					currentNavItem = currentNavItem.parent;
				} while (currentNavItem);
				return (i18n.get('solutionBuilderAgent.components.mx-search-query-group.noRightsToSaveForNonAdmin') || '')
					.replace('{current_nav_path}', currentNavPath)
					.replace('{allowed_nav_path}', allowedNavPath);
			}
		}

		return {
			restrict: 'E',
			scope: {},
			bindToController: {
				group: '=',
				parent: '=',
				context: '=',
				level: '@',
				showSaveBtn: '@',
				showTestQueryBtn: '@',
				readOnly: '<?',
			},
			compile: function (element) {
				return recursion.compile(element);
			},
			controller: MxSearchQueryGroupCtrl,
			controllerAs: 'vm',
			template: template,
		};
	},
]);
